import { Instance, types } from 'mobx-state-tree';

const StudentWorkingOffLesson = types.model('StudentWorkingOffLesson', {
	cover_url: types.maybeNull(types.string),
	gradebook_id: types.maybeNull(types.number),
	lesson_id: types.maybeNull(types.number),
	lesson_name: types.optional(types.string, ''),
	program_group_id: types.maybeNull(types.number),
	program_group_name: types.optional(types.string, ''),
	program_id: types.maybeNull(types.number),
	program_name: types.optional(types.string, ''),
	schedule_lesson_id: types.maybeNull(types.number),
	schedule_lesson_name: types.maybeNull(types.string),
	schedule_lesson_start: types.maybeNull(types.string),
});

export default StudentWorkingOffLesson;

export interface IStudentWorkingOffLessonModel extends Instance<typeof StudentWorkingOffLesson> {}
